export function formatPaidUntilDate(iso) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  if (!match) {
    return '';
  }
  return `${match[3]}.${match[2]}.${match[1]}`;
}
